package one.healthium.med.presentation.navigation.today

import androidx.compose.runtime.Composable
import one.healthium.today.ui.med.TodayScreen

@Composable
fun TodayContent(
    component: TodayComponent,
) {
    TodayScreen(component)
}